import styled from 'styled-components';

export const H3 = styled.h3`
  font-size: 16px;
  line-height: 1.5;
  font-weight: normal;
  white-space: pre-wrap;
  color: ${({ theme: { text: { h3 } } }) => h3.color};
`;
